import React, { useState } from 'react';

const CodeWidget = ({ onCodeSubmitted }) => {
  const [code, setCode] = useState('');

  const handleSubmit = () => {
    if (!code.trim()) return;
    onCodeSubmitted(code);
  };

  return (
    <div style={{ backgroundColor: 'transparent' }}>
      {/* Centered Container with Max Width */}
      <div className="container d-flex mt-4 justify-content-center" style={{ maxWidth: '1400px' }}>
        {/* Bootstrap row with flex and space between */}
        <div className="row d-flex flex-column flex-lg-row align-items-start justify-content-between w-100">

          {/* Left Text Section */}
          <div
            className="col-12 col-lg-5 mt-3 text-white"
            style={{ maxWidth: '500px', flexShrink: 0 }}
          >
            <h1>Danke für Ihr Interesse an AEW myHome</h1>
            {/*<p className="fs-5">
            Gib deinen <b>persönlichen Vorteilscode</b> ein und erhalte ein Anrecht auf eine <b>Fachberatung</b> bei dir zuhause im Wert von <b>CHF 1000.-</b>
            </p>*/}
          </div>

          {/* Right Code Input Section */}
          <div
            className="col-12 col-lg-5 p-4 shadow-lg rounded bg-white w-100 w-lg-auto"
            style={{ maxWidth: '500px' }}
          >
            <h3 style={{ color: '#161d61' }}>Bitte geben Sie Ihren Code ein.</h3>
            <br />
            <div className="form-floating mb-4">
              <input
                type="text"
                className="form-control"
                id="txtCode"
                placeholder="X63K9"
                name="txtCode"
                onChange={e => setCode(e.target.value)}
                value={code}
              />
              <label htmlFor="txtCode">Code</label>
            </div>
            <br />
            <button
              className="btn btn-primary"
              onClick={handleSubmit}
              disabled={!code.trim()}
            >
            Jetzt profitieren
            </button>
            <br />
            <br />
            <a
  onClick={() => onCodeSubmitted('')}
  style={{
    color: '#161d61',
    textDecoration: 'underline',
    cursor: 'pointer'
  }}
>
  Ich habe keinen Code
</a>

          </div>

        </div>
      </div>
    </div>
  );
};

export default CodeWidget;
